

























import BaseComponent from '@/components/BaseComponent';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class DeleteConfirm extends BaseComponent {
    @Prop({ default: false }) private is_display!: boolean;
    @Prop({ default: '' }) private msg_str!: string;
    @Prop({ default: false }) private check_flg!: boolean;
    private checkbox: boolean = false;

    created() {
        if (!this.check_flg) {
            this.checkbox = true;
        } else {
            this.checkbox = false;
        }
    }
    private closeDialog(v: boolean) {
        this.$emit('closeDialog', v);
    }
}
